import { Profiles } from 'application/repositories/profilesRepository';
import classNames from 'classnames';
import React from 'react';
import { Container, Grid, GridCell, Heading, Icon } from 'ui/components';
import EmailIcon from 'ui/icons/email-icon.svg';
import PatternEight from 'ui/icons/icon-pattern-eight.svg';
import PhoneIcon from 'ui/icons/phone-icon.svg';
import styles from './ListVisitCard.module.scss';

export interface ListVisitCardProps {
	className?: string;
	profiles: Profiles;
	heading?: string;
	notificationText?: string;
}

export const ListVisitCard: React.FC<ListVisitCardProps> = ({ className, heading, notificationText, profiles }) => {
	const representatives = profiles?.representatives || [];

	const showComponent = representatives.length > 0;

	return (
		showComponent && (
			<section className={classNames(styles.ListVisitCard)}>
				<Icon className={styles.ListVisitCard_pattern}>
					<PatternEight />
				</Icon>
				<Container width="Standard" className={styles.ListVisitCard_container}>
					<Grid wrap>
						<GridCell>
							{heading && (
								<Heading className={styles.ListVisitCard_heading} headingLevel="h2">
									{heading}
								</Heading>
							)}
							{notificationText && <p className={styles.ListVisitCard_manchet}>{notificationText}</p>}
						</GridCell>
						<GridCell>
							<section className={styles.ListVisitCard_wrapper}>
								{representatives.map((rep) => (
									<div
										key={rep.duty + rep.firstName + rep.lastName}
										className={classNames(styles.ListVisitCard_ContactCard, className)}
									>
										<section className={styles.ListVisitCard_details}>
											<article className={styles.ListVisitCard_header}>
												<Heading headingLevel="h3" style="default">
													{rep.firstName} {rep.lastName}
												</Heading>
												<p>{rep.duty}</p>
											</article>
											<article className={styles.ListVisitCard_body}>
												<section className={styles.ListVisitCard_row}>
													<Icon size="md" aria-hidden={false} className={styles.ListVisitCard_icon}>
														<PhoneIcon viewBox="0 1 20 17" />
													</Icon>
													<a href={`tel:${rep.workContactInformation?.phone}`} className={styles.ListVisitCard_link}>
														{rep.privateContactInformation?.phone}
													</a>
												</section>
												<section className={styles.ListVisitCard_row}>
													<Icon size="md" aria-hidden={false} className={styles.ListVisitCard_icon}>
														<EmailIcon viewBox="0 -0.5 20 13" />
													</Icon>
													<a href={`mailto:${rep.workContactInformation?.email}`} className={styles.ListVisitCard_link}>
														{rep.privateContactInformation?.email}
													</a>
												</section>
											</article>
										</section>
									</div>
								))}
							</section>
						</GridCell>
					</Grid>
				</Container>
			</section>
		)
	);
};
